// angular
import {Component, OnInit, ChangeDetectorRef} from '@angular/core';

// others
import { DocumentsService } from './documents.service';
import { AppService } from '../../../app.service';
import { BaseComponent } from '../../../shared/base.component';
import { AuthService } from '../../../core/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from '../../../shared/base.service';
import { DocumentsModel } from './documents.model';
import { TranslateService } from '@ngx-translate/core';
import { ClinicsService } from '../../../clinics/clinics.service';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { CoreService } from '../../../core/core.service';
@Component({
    selector: 'app-documents',
    styleUrls: ['./documents.component.scss'],
    templateUrl: './documents.component.html',
    providers: [
        DocumentsService,
        BaseService,
        ClinicsService
        ]
})


export class DocumentsComponent extends BaseComponent implements OnInit {
    format = 'DD.MM.YYYY';

    urlAPI = 'documents';
    sortedColumn = 'official_name';
    order = 'desc';
    paginationHidden = true;

    assigneeFilter = [];
    data: any;
    user: any;

    reset = false;
    language = null;
    collapse = [];
    languageChanged = true;
    clinicId = 0;
    errorMessageText = '';
    deviceInnerHeight: number;

    constructor(
        public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public service: DocumentsService,
        public appService: AppService,
        public translateService: TranslateService,
        private cdr: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private clinicService : ClinicsService,
        public coreService: CoreService,
    ) {
        super(authService, router, baseService, appService);

        this.translateService.onLangChange.subscribe(value => {
            this.languageChanged = false;
            this.language = value.lang;

            // Need timeout to re-render select2
            setTimeout(() => {
                this.languageChanged = true;
            }, 500);
        });
    }

    ngOnInit() {
        this.searchInfo = new DocumentsModel();
        this.url = 'documents';
        this.language = localStorage.getItem('language');
        this.user = this.authService.user;
        this.coreService.className = 'documents-dashboard';

        if (!this.isSupperAdmin) {
            return this.getItems();
        }
        this.getItems();
        let isMobile = this.appService.isMobile ? 1 : 0;
        if (isMobile) {
            this.deviceInnerHeight = this.appService.deviceInnerHeight;
        }
    }

    ngOnDestroy() {
        this.coreService.className = null;
    }

    getItems() {
        this.errorMessageText = '';
        this.service.getItems()
            .subscribe(data => {
                    this.data = data;
                    this.isLoading = false;
                },
                (error) => {
                    this.errorMessageText = error.error.error;
                    this.isLoading = false;
                });
    }

    search(filters: string, page: number) {
        // set url query parameters
        this.router.navigate([this.url], {
            queryParams: {
                filters: filters,
                clinic_id: this.clinicId
            }
        });

        if (!this.isUpdated && this.items) {
            return;
        } else {
            this.items = [];
            this.isUpdated = false;
        }

       return this.getItems();
    }


    sort(column: string, isUpdated = true) {
        this.currentPage = 1;
        super.sort(column, isUpdated);
    }

    download(document){
        this.service.download(document.id)
            .subscribe(data => {
                setTimeout(() => {
                    saveAs(data['body'], document['original_file_name']);
                }, 500);
            });
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    isClinicAdmin(){
        return this.user['role_id'] === this.authService.ROLES.CLINIC_ADMIN;
    }

    isSupperAdmin(){
        return this.user['role_id'] === this.authService.ROLES.SUPER_ADMIN;
    }
}
